import { withDependencies } from '@wix/thunderbolt-ioc'
import { loadPmRpc } from '@wix/thunderbolt-commons'
import { ViewerModel, ViewerModelSym } from '@wix/thunderbolt-symbols'
import { InvokeMethodParams, StartSessionParams } from './types'

const APPLE_PAY_IS_NOT_AVAILABLE_ERROR = 'APPLE_PAY_IS_NOT_AVAILABLE_ERROR'
const WIX_ERROR = 'WIX_ERROR'

const applePayHandlers = ({ siteAssets }: ViewerModel) => ({
	getTpaHandlers() {
		const applePayInvokeMethod = async (_id: string, _params: InvokeMethodParams) => {
			// TODO @vsashyn
			return { result: true }
		}

		const applePayStartSession = async (_id: string, params: StartSessionParams) => {
			try {
				const pmRpc = await loadPmRpc(siteAssets.clientTopology.moduleRepoUrl)
				const api = await pmRpc.api.request(params.callbackApiId, {
					target: window.document.getElementsByTagName('iframe')[0],
				})
				console.log("We've got an API:", api)
				// TODO @vsashyn
				return {}
			} catch (e) {
				return {
					error: {
						errorCode: WIX_ERROR,
					},
				}
			}
		}

		return {
			applePayInvokeMethod: wrapWithError(applePayInvokeMethod),
			applePayStartSession: wrapWithError(applePayStartSession),
		}
	},
})

const wrapWithError = (fn: any) => {
	if (!window.ApplePaySession) {
		return () => ({
			error: {
				errorCode: APPLE_PAY_IS_NOT_AVAILABLE_ERROR,
			},
		})
	}
	return fn
}

export const ApplePayTPAHandlers = withDependencies([ViewerModelSym], applePayHandlers)
